import styled from '@emotion/styled';
import React from 'react';

const SvgMotion = styled.svg`
  height: 100%;
  width: 100%;
`;

const RectMotion = styled.rect`
  fill: transparent;
`;

const ContainerMotion = styled.div`
  width: ${(props) => props.size || 250}px;
  height: ${(props) => props.size || 250}px;
  position: absolute;
  top: calc(50% - ${(props) => (props.size ? props.size / 2 : 125)}px);
  left: calc(50% - ${(props) => (props.size ? props.size / 2 : 125)}px);
`;

const CircleLeftMotion = styled.path`
  animation: CircleLeftAnimateMotion 4s linear infinite;
  @keyframes CircleLeftAnimateMotion {
    0% {
      animation-timing-function: cubic-bezier(0.68, 0.2, 0.91, 0.57);
      transform: translateX(0px) translateY(0px);
    }
    16.6% {
      animation-timing-function: jump-none;
      transform: translateX(0px) translateY(0px);
    }
    33.3% {
      transform: translateX(0px) translateY(0px);
    }
    49.8% {
      animation-timing-function: cubic-bezier(0.46, -0.01, 0.49, 1);
      transform: translateX(-100px) translateY(-170.9px);
    }
    66.4% {
      animation-timing-function: cubic-bezier(0.68, 0.2, 0.91, 0.57);
      transform: translateX(0px) translateY(0px);
    }
    83% {
      animation-timing-function: jump-none;
      transform: translateX(0px) translateY(0px);
    }
  }
`;

const MiddleCircleMotion = styled.path`
  transform-box: fill-box;
  transform-origin: center;
  animation: MiddleCircleAnimateMotion 4s linear infinite;
  @keyframes MiddleCircleAnimateMotion {
    0% {
      animation-timing-function: cubic-bezier(0.68, 0.2, 0.91, 0.57);
      transform: translateY(0px);
    }
    16.6% {
      animation-timing-function: jump-none;
      transform: translateY(130.9px);
    }
    33.3% {
      transform: translateY(0px);
    }
    49.8% {
      animation-timing-function: cubic-bezier(0.46, -0.01, 0.49, 1);
      transform: translateY(130.9px);
    }
    66.4% {
      transform: translateY(0px);
    }
    83% {
      animation-timing-function: jump-none;
      transform: translateY(130.9px);
    }
  }
`;
const RightWingMotion = styled.path`
  transform-box: fill-box;
  transform-origin: center;
  animation: RightWingAnimateMotion 4s linear infinite;
  @keyframes RightWingAnimateMotion {
    0% {
      animation-timing-function: cubic-bezier(0.68, 0.2, 0.91, 0.57);
    }
    16.6% {
      animation-timing-function: jump-none;
      transform: rotate(0deg) translateX(0px);
    }
    33.3% {
      transform: rotate(0deg) translateX(0px);
    }
    49.8% {
      animation-timing-function: cubic-bezier(0.46, -0.01, 0.49, 1);
      transform: rotate(32deg) translateX(0px) translateY(20px);
    }
    66.4% {
      animation-timing-function: cubic-bezier(0.68, 0.2, 0.91, 0.57);
      transform: rotate(0deg) translateX(0px);
    }
    83% {
      animation-timing-function: jump-none;
      transform: rotate(63deg) translateX(0px);
    }
  }
`;

const LeftWing1Motion = styled.path`
  transform-box: fill-box;
  transform-origin: center;
  animation: LeftWing2AnimateMotion 4s linear infinite;
`;
const LeftWing2Motion = styled.path`
  transform-box: fill-box;
  transform-origin: center;
  animation: LeftWing2AnimateMotion 4s linear infinite;
  @keyframes LeftWing2AnimateMotion {
    0% {
      animation-timing-function: cubic-bezier(0.68, 0.2, 0.91, 0.57);
      transform: rotate(0deg) translateX(0px);
    }
    16.6% {
      animation-timing-function: jump-none;
      transform: rotate(-61.13deg) translateX(0px);
    }
    33.3% {
      transform: rotate(0deg) translateX(0px);
    }
    49.8% {
      animation-timing-function: cubic-bezier(.46,-0.01,.49,1);
      transform: translateX(-100px) rotate(-30deg);
    }
    66.4% {
      animation-timing-function: cubic-bezier(1,-0.01,1,-0.02);
      transform: rotate(0deg) translateX(0px);
    }
    83% {
      animation-timing-function: jump-none;
      transform: rotate(0deg) translateX(0px);
    }
`;

const AryLoadingAnimationMotion = ({ size }) => (
  <div>
    <ContainerMotion size={size}>
      <SvgMotion
        viewBox="0 0 880 560"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <RectMotion width="880" height="560" fill="white" />
        <RightWingMotion
          d="M637.918 417.571C576.424 317.92 514.931 218.278 453.446 118.627C444.516 104.156 423.315 104.549 414.928 119.342C409.66 128.642 404.384 137.943 399.116 147.244C395.095 154.348 395.265 163.073 399.565 170.014C455.629 260.502 511.694 350.99 567.759 441.479C571.889 448.147 579.226 452.168 587.082 452.065C597.779 451.918 608.475 451.78 619.172 451.634C636.542 451.406 647.034 432.34 637.918 417.571Z"
          fill="#0077b6"
        />
        <LeftWing1Motion
          d="M500.941 218.92L372.237 440.847C368.047 448.07 360.281 452.505 351.877 452.469L262.318 452.106C244.387 452.034 233.214 432.802 242.148 417.389L416.186 117.111C425.241 101.491 448.026 101.642 456.867 117.378L501.092 196.092C505.09 203.204 505.028 211.87 500.941 218.92Z"
          fill="#0096c7"
        />
        <LeftWing2Motion
          d="M463.693 156.803C319.829 409.834 313.464 419.849 300.716 439.862C299.845 441.226 297.318 445.172 292.55 448.254C286.117 452.414 279.667 452.525 277.141 452.438C272.184 452.377 267.234 452.324 262.277 452.263C244.377 452.19 233.224 432.95 242.142 417.53L415.875 117.116C424.914 101.489 447.658 101.64 456.484 117.383C456.674 117.72 458.105 119.698 459.743 122.263C461.191 124.551 462.906 127.237 464.311 130.113C464.673 130.855 467.095 135.847 467.809 140.043C469.11 147.728 465.013 154.48 463.693 156.803Z"
          fill="#00b4d8"
        />
        <CircleLeftMotion
          d="M381.628 260.044C395.23 261.583 407.504 251.803 409.043 238.201C410.581 224.598 400.802 212.324 387.199 210.786C373.597 209.247 361.323 219.027 359.785 232.629C358.246 246.231 368.026 258.505 381.628 260.044Z"
          fill="#0077b6"
        />
        <MiddleCircleMotion
          d="M460.97 409.849C474.572 411.387 486.846 401.608 488.385 388.005C489.923 374.403 480.144 362.129 466.541 360.59C452.939 359.052 440.665 368.832 439.126 382.434C437.588 396.036 447.367 408.31 460.97 409.849Z"
          fill="#00b4d8"
        />
      </SvgMotion>
    </ContainerMotion>
  </div>
);

export default AryLoadingAnimationMotion;
